import React from 'react';
import TeamAccessMap from '../TeamAccessMap';

const TeamAccessMapSection: React.FC = () => <TeamAccessMap />;

export default TeamAccessMapSection;
